import React from "react"
import { default as SlickSlider } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "style/CMSSlider.scss"
import { Button } from "semantic-ui-react"
// import "react-responsive-carousel/lib/styles/carousel.min.css"


export default class CMSSlider extends React.Component {

  state = {
    isDragging: false
  }

  toggleDragging = () => this.setState({ isDragging: !this.state.isDragging });
  onClickHandler = (event) => {
    if (this.props.isDragging) {
      event.preventDefault();
    } else {
      return true
    }
  };

  render() {

    const { slidesToShow = 1, autoplaySpeed = 3000, autoplay = false, slidesToScroll = 1, centerMode = false, centerPadding = "0px", dots = true } = this.props
    const settings = {
      dots,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow,
      slidesToScroll,
      centerMode,
      centerPadding,
      autoplay,
      autoplaySpeed
    };

    const { isDragging } = this.state
    return (
      <React.Fragment>
        <Button icon="big arrow alternate circle left" style={{ position: "absolute", top: "30%", left: "2%", zIndex: "9", backgroundColor: "#ffffff" }} onClick={() => this.slider.slickPrev()}></Button>
        <div onClick={() => this.slider.slickNext()}>
          <SlickSlider
            ref={slider => (this.slider = slider)}
            {...settings}
            className="CMSSlider"
          >
            {this.props.children}
          </SlickSlider>
        </div>
        <Button icon="big arrow alternate circle right" style={{ position: "absolute", top: "30%", right: "2%", zIndex: "9", backgroundColor: "#ffffff" }} onClick={() => this.slider.slickNext()}></Button>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/theme/mags/components/Slider/Slider.js